module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/conditioner@3x_35b598.png";